import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography, Box, Skeleton } from '@mui/material';
import { getPeerPeerAffinityData } from '../../../../redux/thunks/affinityHubThunk';
import { DonutChart, SemiDonutChart } from '../../../shared';
import { VIRTUAL_CHART_OPTIONS,
    IN_PERSON_CHART_OPTIONS,
    SEMI_DONUT_CHART_OPTIONS } from './constants';

export default function Channels(props) {
    const { } = props;
    const dispatch = useDispatch();
    const { peerToPeer } = useSelector(state => state.affinityHub);
    const {
        virtualChannel, inPersonChannel, peerToPeerChannel, isLoading 
    } = peerToPeer;
    useEffect(() => {
        dispatch(getPeerPeerAffinityData());
    }, []);
    return (
        <Box className="box-sizing-border-box">
            <Typography className="text-md-semi-bold gray-900">
                Peer To Peer
            </Typography>
            <Box className="padding-tb-24-rl-0">
                <Grid container className="flex-row br-16px" spacing={'24px'}>
                    {/*  Virtual */}
                    <Grid item lg={4} md={12} sm={12} xl={4} xs={12}>
                        <Box className="padding-24px bg-gray-50 br-16px">
                            <Box>
                                <Typography className="text-md-semi-bold gray-900">
                                    Virtual
                                </Typography>
                            </Box>

                            {isLoading ? <Skeleton data-testid="skeleton-loading" height={250}/> : <Box data-testid="affinity_hub_Virtual_chart" key={`virtual-${virtualChannel.chartSeries?.length}`}>
                                <DonutChart
                                    chartOptions={
                                        {
                                            ...VIRTUAL_CHART_OPTIONS, 
                                            labels: virtualChannel.labels
                                        }
                                    }
                                    chartSeries={virtualChannel.chartSeries}
                                />
                            </Box> }
                        </Box>
                    </Grid>
                    {/* Peer to Peer Channel Affinity */}
                    <Grid item lg={4} md={12} sm={12} xl={4} xs={12}>
                        <Box className="padding-24px bg-gray-50 br-16px height-100 flex-column-space-between">
                            <Box>
                                <Typography className="text-md-semi-bold gray-900">
                                    Peer to Peer Channel Affinity
                                </Typography>
                            </Box>
                            {isLoading ? <Skeleton data-testid="skeleton-loading_peer_to_peer" height={250}/> : <SemiDonutChart
                                chartOptions={
                                    {
                                        ...SEMI_DONUT_CHART_OPTIONS,
                                        labels: peerToPeerChannel.labels
                                    }
                                }
                                chartSeries={peerToPeerChannel.chartSeries}
                                data_testid="affinity_hub_Peer_to_Peer_chart"
                            />}
                        </Box>
                    </Grid>
                    {/* In-Person */}
                    <Grid item lg={4} md={12} sm={12} xl={4} xs={12}>
                        <Box className="padding-24px bg-gray-50 br-16px">
                            <Box>
                                <Typography className="text-md-semi-bold gray-900">
                                    In-Person
                                </Typography>
                            </Box>
                            {isLoading ? <Skeleton data-testid="skeleton-loading_in_person" height={250}/> : <DonutChart
                                chartOptions={
                                    {
                                        ...IN_PERSON_CHART_OPTIONS, 
                                        labels: inPersonChannel.labels
                                    }
                                }
                                chartSeries={inPersonChannel.chartSeries}
                                data_test_id="affinity_hub_In_Person_chart"
                            />}
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}
